import { useEventManagement } from '@/features/events/hooks/use-event-management';
import { AddEventForm } from './add-event-form';
import { DataTable } from './data-table';
import { getEventColumns } from './event-columns';

export function EventManagement() {
  const {
    cancelEditing,
    deleteEvent,
    editForm,
    editingId,
    events,
    initialPageIndex,
    loading,
    pageSize,
    processing,
    saveEdit,
    startEditing,
  } = useEventManagement();

  const columns = getEventColumns(
    editingId,
    editForm,
    startEditing,
    saveEdit,
    cancelEditing,
    deleteEvent,
    processing,
  );

  return (
    <div className='container mx-auto p-4'>
      <h1 className='text-2xl font-bold mb-4'>Event Management</h1>

      <AddEventForm />

      <DataTable
        columns={columns}
        data={events}
        editForm={editForm}
        editingId={editingId}
        initialPageIndex={initialPageIndex}
        loading={loading}
        onCancel={cancelEditing}
        onDelete={deleteEvent}
        onEdit={startEditing}
        onSave={saveEdit}
        pageSize={pageSize}
      />
    </div>
  );
}
